import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import QualifiedGolfers from './QualifiedGolfers';
import app, { EVENT_DEVICE_TYPE_CHANGED } from '../../../general/js/app';
import eventBus from '../../../general/js/event-bus';
import reducer from './reducer';
import creators from './actions';

export default class QualifiedGolfersComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        const {
            previewPlayers, totalPlayersCount, events, translations
        } = this.options;

        this.store = createStore(reducer, {
            previewPlayers,
            totalPlayersCount,
            events,
            translations,
            deviceType: app.deviceTypeByViewport,
        });

        this.init();
    }

    init() {
        this.render();
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    onDestroy() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    onDeviceTypeChanged = (oldDeviceType, newDeviceType) => {
        this.store.dispatch(creators.changeDeviceType(newDeviceType));
    }

    render() {
        ReactDOM.render(<Provider store={this.store}>
            <QualifiedGolfers/>
        </Provider>, this.element);
    }
}
